export enum TabId {
  SETUP = 'Setup Details',
}